import React, { Component } from 'react';
import VideoWrapper from './Viewer/VideoWrapper'
import WhiteboardWrapper from './Viewer/WhiteboardWrapper'
// import Overlay from './Viewer/Overlay'
import TranscriptViewer from './Viewer/TranscriptViewer'
import TranscriptEditor from './Viewer/TranscriptEditor'
// import WordEditor from './Viewer/WordEditor'
import Captions from './Viewer/Captions'
import Controls from './Viewer/Controls'
import Thumbnails from './Viewer/Thumbnails'
import SplitPane from 'react-split-pane';
import './Viewer.css';

class Viewer extends Component {
	constructor(props) {
		super(props);
		this.videoRef = React.createRef();
		this.splitPaneWidthRef = React.createRef();

		this.state = {
			lastPaneSize: ''
		};
	}

	componentDidMount() {
		window.addEventListener('hashchange', this.gotoHandler);
	}

	componentWillUnmount() {
		window.removeEventListener('hashchange', this.gotoHandler);
	}

	// Goto on change
	gotoHandler = () => {
		const urlHash = window.location.hash;
		if (urlHash.includes("#goto=")) {
			let secondsString = urlHash.substring(6);
			if(isNaN(secondsString) || Number(secondsString) % 1 !== 0 || Number(secondsString) > Math.floor(this.state.duration)) {
				console.error("URL `goto` hash parameter is not valid. It must be an integer representing seconds elapsed since the beginning of the capture.");
			} else {
				let time = Number(secondsString);
				this.triggerHandler('seek', time);
				this.triggerHandler('play');
			}
		}
	}

	triggerHandler = (event, params = {}) => {
		switch (event) {
			case 'toggleCaptions':
				this.props.updatePlayerState({ captions: !this.props.data.captions });
				break;
			default:
				this.videoRef.current.handleEvent(event, params);
		}
	}

	ondragfinishedHandler = (size) => {
		// Set width as a percentage
		// If a pixel value is used, when the browser is resized, it never recalculates size relative to the other pane
		let splitPaneWidth = this.splitPaneWidthRef.current.splitPane.clientWidth;
		this.setState({ lastPaneSize: (size/splitPaneWidth)*100 + '%' });
	}

	render() {
		// TODO: REMOVE height calc? - if so calculate pane height style={{ height: paneHeight }}
		var showVideoWrapper = false,
			showWhiteboardWrapper = false,
			defaultSize = undefined,
			size = 0,
			minSize = 150,
			primary = 'first';

		if (this.props.data.visiblePresets.stage.length > 0) {
			for (var i = this.props.data.visiblePresets.stage.length - 1; i >= 0; i--) {
				if (this.props.data.visiblePresets.stage[i].visible === true) {
				showVideoWrapper = true;
				}
			}
		}

		if (this.props.data.visiblePresets.whiteboard.length > 0) {
			for (var j = this.props.data.visiblePresets.whiteboard.length - 1; j >= 0; j--) {
				if (this.props.data.visiblePresets.whiteboard[j].visible === true) {
				showWhiteboardWrapper = true;
				}
			}
		}

		if (showVideoWrapper === true && showWhiteboardWrapper === true) {
			size = undefined;
			minSize = undefined;

			if (this.state.lastPaneSize !== '') {
				size = this.state.lastPaneSize;
				defaultSize = undefined;
			} else {
				defaultSize = '30%';
			}
		}

		if (showVideoWrapper === false && showWhiteboardWrapper === true) {
			defaultSize = '100%';
			size = '100%';
			minSize = '100%';
			primary = 'second';
		}

		if (showVideoWrapper === true && showWhiteboardWrapper === false) {
			defaultSize = '100%';
			size = '100%';
			minSize = '100%';
		}

		var overallDimensions = this.props.data.dimensions;

		var extraHeight = 	overallDimensions.extraHeaderHeight +
							overallDimensions.wordeditorHeight*this.props.data.wordeditor +
							overallDimensions.captionsHeight*this.props.data.captions +
							overallDimensions.controlsHeight*this.props.data.controls +
							overallDimensions.compactControlsHeight*(!this.props.data.controls) +
							overallDimensions.thumbnailsHeight*this.props.data.thumbnails;

		var splitPaneWidth = '100%',
			showFeatureContentPane = false;

		if (this.props.data.transcript) {
			splitPaneWidth = 'calc(100% - 450px)';
			showFeatureContentPane = true;
		}

		if (this.props.data.transcripteditor) {
			splitPaneWidth = 'calc(100% - 450px)';
			showFeatureContentPane = true;
		}

	return (
		<div className="viewer">
			<div style={{ height: 'calc(100% - ' + extraHeight + 'px)', position: 'relative' }}>
				<SplitPane ref={this.splitPaneWidthRef} onDragFinished={this.ondragfinishedHandler} style={{ width: splitPaneWidth }} split="vertical" minSize={minSize} defaultSize={defaultSize} size={size} primary={primary}>
					<VideoWrapper key={this.props.data.recording.info.codec_id} ref={this.videoRef} data={this.props.data} updatePlayerState={this.props.updatePlayerState} />
					{ showWhiteboardWrapper === true ? <WhiteboardWrapper data={this.props.data} updatePlayerState={this.props.updatePlayerState} /> : <div></div> }
				</SplitPane>
				{ showFeatureContentPane ?
					<div className="feature-content-pane">
						{ this.props.data.transcript ? <TranscriptViewer data={this.props.data} trigger={this.triggerHandler} /> : null }
						{ this.props.data.transcripteditor ? <TranscriptEditor data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} /> : null }
					</div> : null
				}
			</div>
			{/*<Overlay data={this.props.data} video={this.videoRef} />*/}
			{/*this.props.data.wordeditor ? <WordEditor data={this.props.data} trigger={this.triggerHandler} /> : null */}
			<Captions data={this.props.data} />
			<Controls data={this.props.data} trigger={this.triggerHandler} updatePlayerState={this.props.updatePlayerState} />
			{ this.props.data.supportsThumbnails ? <Thumbnails data={this.props.data} trigger={this.triggerHandler} /> : null }
	  </div>
	);
  }
}

export default Viewer;